import { useMemoizedFn } from 'ahooks';
import { Button, ButtonProps } from 'antd';
import { withErrorBoundary } from 'components/ErrorBoundary/withErrorBoundary';
import withSuspense from 'components/withSuspense';
import { useFlagrDashboardRankValue } from 'hooks/business/system/useFlagr';
import { useTranslate } from '@tolgee/react';
import { PerformanceName } from 'services/api/dashboard';
import useDrawerContext from './hooks/useDrawer';

interface AheadLinkButtonProps extends Omit<ButtonProps, 'type' | 'onClick'> {
  performanceName: PerformanceName;
}

function AheadLinkButton(props: AheadLinkButtonProps) {
  const { performanceName, ...rest } = props;
  const { setTrendValue } = useDrawerContext();
  const { t } = useTranslate();
  const flagr = useFlagrDashboardRankValue();
  const setTrend = useMemoizedFn(() => {
    setTrendValue({
      type: 'rank',
      visible: true,
      params: {
        performanceName,
      },
    });
  });
  return flagr?.allowed ? (
    <Button type="link" onClick={setTrend} {...rest}>
      {t('ViewDashboard.查看行业排名')}
    </Button>
  ) : null;
}
export default withErrorBoundary(withSuspense(AheadLinkButton, { fallback: null }), {
  fallback: null,
});
